<template lang="pug">
  .component-subscription-controller(v-if="item")
    .row
      .columns.medium-6
        driver(:type="'driver-card'", :item="item.client.main_driver")
    .row.columns
      tab-headers(:tabs="tabHeaders", :id="'subscription-details'", :activeIndex="0")
        tab-content(:headerName="'Subscription'", :active="true")
          subscription(:item="item", :type="'card-header-include'")
          subscription(:item="item", :type="'subscription-action-details'")
        tab-content(:headerName="'Logs'" v-if="$acl('index-log')")
          base-list(:component="component", :dataLoader="dataLoader")

</template>
<script type="text/babel">
  import StatisticsCard5 from "components/structure/ui/StatisticsCard5";
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import RouterTabHeaders from "components/structure/foundation/RouterTabHeaders";
  import Client from "components/backoffice/Client";
  import Subscription from "components/backoffice/Subscription";
  import Driver from 'components/backoffice/Driver'
  import TabHeaders from "../../../components/structure/foundation/TabHeaders.vue";
  import TabContent from "../../../components/structure/foundation/TabContent.vue";
  import BaseList from "../BaseList";

  export default {
    name: "SubscriptionController",
    components: {
      BaseList,
      TabContent,
      TabHeaders,
      Driver,
      Subscription,
      Client,
      RouterTabHeaders,
      StatisticsCard5,
      KeplerBackofficeSdk
    },
    data() {
      return {
        logs: [],
        component: require('src/components/backoffice/Log.vue'),
        tabHeaders: ['Subscription']
      }
    },
    created() {
      if (this.$acl('index-log')) {
        this.tabHeaders.push('Logs')
        this.dataLoader((data) => {
          this.logs = data
        }, 1, 10)
      }
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.logs
          .list(page, resultsPerPage)
          .all('subscription', this.$route.params.id,
            (data) => {
              callback(data)
            })
      }
    },
    computed: {},
    props: ['item'],

  }
</script>



// WEBPACK FOOTER //
// Subscription.vue?239b30d4